import { SearchInput } from '../shared';
import { SortOrder, MeetingRoomScheduleSortType } from '../enums';
import moment from 'moment';

export class GetMeetingRoomSchedulesInput extends SearchInput<MeetingRoomScheduleSortType> {
    public fromDate: moment.Moment | null = null;
    public toDate: moment.Moment | null = null;
    public customerId: number | null = null;
    public meetingRoomId: number | null = null;

    constructor() {
        super(MeetingRoomScheduleSortType.FromDateTime);
        this.sortOrder = SortOrder.Ascending;
    }
}